import { render, staticRenderFns } from "./auditDialog.vue?vue&type=template&id=4af68569&scoped=true"
import script from "./auditDialog.vue?vue&type=script&lang=js"
export * from "./auditDialog.vue?vue&type=script&lang=js"
import style0 from "./auditDialog.vue?vue&type=style&index=0&id=4af68569&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af68569",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af68569')) {
      api.createRecord('4af68569', component.options)
    } else {
      api.reload('4af68569', component.options)
    }
    module.hot.accept("./auditDialog.vue?vue&type=template&id=4af68569&scoped=true", function () {
      api.rerender('4af68569', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/noticeManage/components/auditDialog.vue"
export default component.exports